import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { loadableReady } from '@loadable/component';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import ThemeProvider from '../common/provider/ThemeProvider';
import GdprCookieConsentWrapper from '../common/component/GdprCookieConsentWrapper';
import store from './redux/store';
import { getMMT_HLD_OBJ } from '../common/utils/appUtils';
import OmnitureUtils from '../common/utils/Omniture/OmnitureUtils';
import { propVarsToTrack, setClickVars, setLoadVars } from './helpers/trackingUtils';
import Analytics from '../../analytics';
import '../common/font-icons/style.css';

/**
 * Initialize basic ominiture config
 */
OmnitureUtils.addTrackVars(propVarsToTrack);
OmnitureUtils.init(
  {
    setLoadVars,
    setClickVars,
  },
  { skipLoad: true }
);
OmnitureUtils.setStore(store);
Analytics.init(Analytics.PAGE_NAMES.LISTING, 'v3');
const AppWithProviders = () => (
  <Provider store={store}>
    <ThemeProvider>
      <Router>
        <App />
        <GdprCookieConsentWrapper />
      </Router>
    </ThemeProvider>
  </Provider>
);

loadableReady(() => {
  const { fromSEO } = getMMT_HLD_OBJ();
  const container = document.getElementById('root');

  if (fromSEO) {
    hydrateRoot(container, <AppWithProviders />);
  } else {
    const root = createRoot(container);
    root.render(<AppWithProviders />);
  }
});
